<template>
  <svg
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    viewBox="0 0 24 24"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line
      x1="21"
      y1="12"
      x2="9"
      y2="12"
    />
  </svg>
</template>

<script>
export default {
  name: "LogoutIcon",
  props: {
    size: { type: Number, default: 14 },
  },
};
</script>
